<template>
  <label v-if="false" class="search-wrap" for="search">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 22 22"
      width="22px"
      height="22px"
    >
      <g fill="none" fill-rule="evenodd">
        <path
          fill="#fff"
          d="M7.69921875 3.07421875C9.29037254 1.48306496 11.2031138.6875 13.4375.6875s4.1471275.79556496 5.7382812 2.38671875C20.766935 4.66537254 21.5625 6.57811383 21.5625 8.8125c0 2.2343862-.795565 4.1471275-2.3867188 5.7382812C17.5846275 16.141935 15.6718862 16.9375 13.4375 16.9375c-1.9296971 0-3.63931547-.6093689-5.12890625-1.828125l-6.44921875 6.5-1.21875-1.21875 6.5-6.4492187C5.92186891 12.4518155 5.3125 10.7421971 5.3125 8.8125c0-2.23438617.79556496-4.14712746 2.38671875-5.73828125zM18.0078125 4.2421875C16.7552021 2.95572273 15.2317798 2.3125 13.4375 2.3125s-3.3261655.63475928-4.59570312 1.90429688C7.57225928 5.48633447 6.9375 7.0182202 6.9375 8.8125c0 1.7942798.63475928 3.3261655 1.90429688 4.5957031C10.1113345 14.6777407 11.6432202 15.3125 13.4375 15.3125c1.7942798 0 3.3261655-.6347593 4.5957031-1.9042969C19.3027407 12.1386655 19.9375 10.6067798 19.9375 8.8125c0-1.7942798-.6432227-3.31770207-1.9296875-4.5703125z"
        />
      </g>
    </svg>
    <autocomplete
      placeholder="Raðnúmer, aukahlutir"
      source="/site/search?q="
      results-property="items"
      @selected="addFilterSearch"
      results-display="name"
    >
    </autocomplete>
  </label>
</template>

<script>
import Autocomplete from "vuejs-auto-complete";

export default {
  components: {
    Autocomplete
  },
  methods: {
    addFilterSearch: function(group) {
      let param = group.selectedObject;

      setFilter(param.type, param.id);

      if (!this.isMainPage()) {
        delete filters.verdtilbod;
        let d = window.btoa(JSON.stringify(filters));
        let url = "?" + d;
        window.location.href = "/" + url;
      }
    },
    isMainPage: function() {
      return isMainPage();
    }
  }
};
</script>
